var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPower10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.06866V4.99969H11.1723V7.06866H11.9999Z",
    fill: "#C7CAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.249949 8.59115L0.249949 3.40384C0.249949 3.26032 0.366227 3.14404 0.509743 3.14404L10.6626 3.14404C10.8061 3.14404 10.9224 3.26032 10.9224 3.40384L10.9224 8.59115C10.9224 8.73466 10.8061 8.85094 10.6626 8.85094L0.509743 8.85094C0.366227 8.85094 0.249949 8.73466 0.249949 8.59115Z",
    fill: "#E7ECED",
    stroke: "#EB5757",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00012 2.96643L0.189661 2.96643C0.0849683 2.96643 0.00012207 3.18703 0.00012207 3.45923L0.00012207 8.47363C0.00012207 8.74583 0.0849683 8.96643 0.189661 8.96643H1.00012L1.00012 2.96643Z",
    fill: "#EB5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower10);
export default __webpack_public_path__ + "static/media/power-10.ccc8d968f78b34664c0e3d13e909ca4c.svg";
export { ForwardRef as ReactComponent };